import React, { useContext } from 'react';
import PageContext from '../global_state/context/PageContext';
import { PageType } from 'types/PageI';
import { BiSupport } from 'react-icons/bi'

import SCSS from '../assets/scss/UserProfile.module.scss';

import content from 'languages/UserProfile.json'

function UserProfile() {
    
    const {page, dispatchPage}  = useContext(PageContext)
    let lang = page.settings.language

    const handleSwitchPage = (page: PageType) => {
        dispatchPage({type: "render", payload: {page: page}})
    }

    return(
        <div className={SCSS.user_profile}>
            <h3>
                <span className={SCSS.thin}>{content[lang].welcome_to_xplore_1} </span>
                <span>{content[lang].welcome_to_xplore_2}</span>
            </h3>            
            <div className={SCSS.user_actions}>
                
                <div 
                    onClick={() => {handleSwitchPage(PageType.memberships)}} 
                    className={SCSS.box}>
                    {/* <img src="" alt="" /> */}
                    <div className={SCSS.title}>
                        <div>{content[lang].memberships_1}</div>
                        <div>{content[lang].memberships_2}</div>
                    </div>
                </div>

                <div 
                    onClick={() => {handleSwitchPage(PageType.reservations)}} 
                    className={SCSS.box}>
                    {/* <img src="" alt="" /> */}
                    <div className={SCSS.title}>
                        <div>{content[lang].reservations_1}</div>
                        <div>{content[lang].reservations_2}</div>
                    </div>
                </div>

                <div 
                    onClick={() => {handleSwitchPage(PageType.ehsop)}} 
                    className={SCSS.box}>
                    {/* <img src="" alt="" /> */}
                    <div className={SCSS.up}>
                        <div className={[SCSS.title, SCSS.eshop].join(" ")}>
                            <div>{content[lang].shop_1}</div>
                            <div>{content[lang].shop_2}</div>
                        </div>
                        <div className={SCSS.subtitle}>
                            {content[lang].shop_warning}
                        </div>
                    </div>
                    <div className={SCSS.right_placeholder}></div>
                </div>

                <div 
                    onClick={() => {handleSwitchPage(PageType.credit_history)}} 
                    className={SCSS.box}>
                    <div className={[SCSS.title].join(" ")}>
                        <div>{content[lang].credit_history_1}</div>
                        <div>{content[lang].credit_history_2}</div>
                    </div>
                </div>
            </div>

            <div className={SCSS.footer}>
                <div className={SCSS.text}>
                    <BiSupport/>
                    {content[lang].need_help}
                </div>
                <div className={SCSS.number}><a href={"tel:" + content[lang].tel_number}>{content[lang].tel_number}</a></div>
            </div>
        </div>
    )   
}

export default UserProfile;